// extracted by mini-css-extract-plugin
export var chevron = "_lj-3";
export var chevronRotated = "_lj-4";
export var image = "_lj-1";
export var imageContainer = "_lj-0";
export var shippingAddress = "_lj-2";